import { useNavigate } from "react-router";
import useQuery from "../useQuery";

export const DEFAULT_INVENTORY_FILTER_PARAMS = {
  warehouseId: "warehouseId",
  inventory: "inventory",
  costCenterId: "costCenterId",
};

export const inventorySelectionFromParam = inventoryFilter => {
  if (inventoryFilter === "all") return "showAllInventory";
  if (inventoryFilter === "out_of_warehouse") return "showOutOfWarehouse";
  if (inventoryFilter === "store_page_scope") return "showStorePageScope";
  return "showOnlyInStockItems";
};

export const inventorySelectionFromVariables = variables => {
  if (variables?.showDeployedAssets) return "showOutOfWarehouse";
  if (variables?.storePage && variables?.hideDepletedAssets) return "showStorePageScope";
  if (variables?.hideDepletedAssets) return "showOnlyInStockItems";
  return "showAllInventory";
};

export default function useInventoryFilters({
  variables,
  paramKeys = DEFAULT_INVENTORY_FILTER_PARAMS,
  inventoryFromParams = false,
} = {}) {
  const navigate = useNavigate();
  const query = useQuery();

  const selected = inventoryFromParams
    ? inventorySelectionFromParam(query.get(paramKeys.inventory))
    : inventorySelectionFromVariables(variables);

  const handleRadioChange = event => {
    const value = event.target.value;
    if (value === "showAllInventory") {
      query.set(paramKeys.inventory, "all");
    } else if (value === "showOnlyInStockItems") {
      query.set(paramKeys.inventory, "in_stock");
    } else if (value === "showOutOfWarehouse") {
      query.set(paramKeys.inventory, "out_of_warehouse");
    } else if (value === "showStorePageScope") {
      query.set(paramKeys.inventory, "store_page_scope");
    }
    navigate({ search: query.toString() });
  };

  const handleWarehouseChange = event => {
    const warehouseId = event.target.value;
    if (warehouseId) {
      query.set(paramKeys.warehouseId, warehouseId);
    } else {
      query.delete(paramKeys.warehouseId);
    }
    navigate({ search: query.toString() });
  };

  const handleCostCenterChange = event => {
    const costCenterId = event.target.value;
    if (costCenterId === "all") {
      query.delete(paramKeys.costCenterId);
    } else {
      query.set(paramKeys.costCenterId, costCenterId);
    }
    navigate({ search: query.toString() });
  };

  return {
    value: selected,
    onChangeInventory: handleRadioChange,
    onChangeWarehouse: handleWarehouseChange,
    onChangeCostCenter: handleCostCenterChange,
  };
}
